import AppAdapter from 'adapters/app';

class CardAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default CardAdapter;